export { default as Tabs } from './Tabs'
export { default as TabContent } from './TabContent'

export * from './Tabs.interface'
